let last=null;
export function kioskLocation(timeout=2500){
 if(last&&Date.now()-last.saved<30000)return Promise.resolve(last.value);
 return new Promise(resolve=>{
  if(!navigator.geolocation){resolve({status:'unsupported'});return;}
  let complete=false;
  const finish=value=>{if(complete)return;complete=true;clearTimeout(timer);last={saved:Date.now(),value};resolve(value);};
  const timer=setTimeout(()=>finish({status:'timeout'}),timeout+200);
  try { navigator.geolocation.getCurrentPosition(position=>finish({status:'available',latitude:position.coords.latitude,longitude:position.coords.longitude,accuracy_m:position.coords.accuracy,timestamp:position.timestamp}),error=>finish({status:error.code===1?'denied':error.code===3?'timeout':'unavailable'}),{enableHighAccuracy:true,timeout,maximumAge:0}); } catch(error) { finish({status:'unavailable'}); }
 });
}
